import { useEffect, useState } from "react";
import { Col, Row } from "antd";
import homeData from "./home-data";
import ProductShowcaseHero from "../../components/HeroSection/ProductShowcaseHero";
import FeatureTextSection from "../../components/FeatureTextSection/FeatureTextSection";
import InformationCard from "../../components/InformationCard/InformationCard";
import CategoryFeatureCard from "../../components/CategoryFeatureCard/CategoryFeatureCard";
import QualityCard from "../../components/QualityCard/QualityCard";

const HomePage = () => {
  const [welcomeTextSection, setWelcomeTextSection] = useState({});
  const [whyChooseUs, setWhyChooseUs] = useState([]);
  const [ourProductsSection, setOurProductsSection] = useState({});
  const [categoryFeatureCard, setCategoryFeatureCard] = useState([]);
  const [infrastructureTechnology, setInfrastructureTechnology] = useState({});
  
  useEffect(() => {
    setWelcomeTextSection(homeData.welcome_text_section);
    setWhyChooseUs(homeData.why_choose_us);
    setOurProductsSection(homeData.our_products_section);
    setCategoryFeatureCard(homeData.category_feature_card);
    setInfrastructureTechnology(homeData.infrastructure_technology);
  }, []);

  return (
    <div className="home-page">
      <ProductShowcaseHero />

      <section className="feature-text-section text-[#2c3e50]">
        <FeatureTextSection
          title={welcomeTextSection.title}
          minisubline={welcomeTextSection.minisubline} 
          color="text-[#ff6b35]"
          description={welcomeTextSection.description}
          className="bg-gray-100 py-20 text-center"
        />
      </section>

      <section className="features-card-info-section bg-gray-100">
        <h2 className="text-4xl md:text-5xl font-extrabold py-8 text-[#2c3e50]">Why Choose Us</h2>
        <div className="max-w-screen-xl mx-auto">
          <Row
            gutter={16}
            className="flex flex-wrap justify-center h-full py-12"
          >
            {whyChooseUs.map((feature, idx) => (
              <Col
                xs={24}
                sm={12}
                md={8}
                lg={6}
                key={idx}
                className="gap-4 mb-3"
              >
                <InformationCard
                  feature={feature}
                  customClassName="bg-white h-full w-full"
                />
              </Col>
            ))}
          </Row>
        </div>
      </section>

      <section className="features-section bg-gray-100">
        <div className="max-w-[1440px] mx-auto px-6">
          <section className="our-products-section text-[#2c3e50]">
            <FeatureTextSection
              title={ourProductsSection.title}
              description={ourProductsSection.description}
            />
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {categoryFeatureCard.map((card, idx) => (
                <CategoryFeatureCard
                  key={idx}
                  image={card.image}
                  title={card.title}
                  description={card.description}
                  features={card.features}
                  link={card.link}
                />
              ))}
            </div>
          </section>
        </div>
      </section>

      {/* Infrastructure & Technology Section */}
      <section className="infrastructure-technology-section bg-white py-20">
        <div className="max-w-screen-xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-extrabold text-[#2c3e50] mb-6">
              {infrastructureTechnology.title}
            </h2>
            <p className="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
              {infrastructureTechnology.description}
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {infrastructureTechnology.features?.map((feature, idx) => (
              <div key={idx} className="bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-shadow duration-300 border border-gray-100">
                <div className="text-center mb-6">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-100 rounded-full text-orange-600 mb-4">
                    {feature.icon}
                  </div>
                  <h3 className="text-xl font-bold text-[#2c3e50] mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Call to Action */}
  
        </div>
      </section>
    </div>
  );
};

export default HomePage;
